
import { NUMBER_0, NUMBER_1 } from '~shared/constants';
import {
  OrderHistoryItem, OrderLine
} from '../models';
import cloneDeep from 'lodash.clonedeep';
import { MarketDetectionUtil } from '~shared/utils/market-detection.util';

export namespace OrderLineGroupUtils {

  export function mapVasOrderLines(orderHistoryItems: OrderHistoryItem[]): OrderHistoryItem[] {
    if (MarketDetectionUtil.isFrenchMarket()) {
      orderHistoryItems.forEach(orderHistoryItem => {
        orderHistoryItem.orderLines = filterVasOrderLine(orderHistoryItem.orderLines);
      });
    }
    return orderHistoryItems;
  }

  export function mapVasOrderLine(orderHistoryItem: OrderHistoryItem): OrderHistoryItem {
    if (MarketDetectionUtil.isFrenchMarket()) {
      orderHistoryItem.orderLines = filterVasOrderLine(orderHistoryItem.orderLines);
    }
    return orderHistoryItem;
  }

  function filterVasOrderLine(orderLines: OrderLine[]): OrderLine[] {
    const clonedOrderLines = cloneDeep(orderLines);
    orderLines.forEach((orderLine) => {
      if (orderLine.referenceLine && !orderLine.referenceProduct) {
        const index = clonedOrderLines.findIndex(x => x.orderLineId === orderLine.referenceLine);
        if (index >= NUMBER_0) {
          clonedOrderLines.splice(index + NUMBER_1, NUMBER_0, orderLine);
          clonedOrderLines[index + NUMBER_1].referenceProduct = clonedOrderLines[index]?.product;
        }
      }

    });
    return clonedOrderLines.filter(orderLine => !orderLine.referenceLine || (orderLine.referenceLine && orderLine.referenceProduct));
  }

}
